import React from 'react';
import cx from 'classnames';
import { TimelineProps } from './types';
import styles from './Timeline.module.scss';

const Timeline: React.FC<TimelineProps> = ({ data, showLineForLastStage }) => {
    return (
        <div className={styles['timeline-wrapper']} data-testid="wrapper">
            {data.map((stage) => {
                const { pointer, stageComponent } = stage;
                return (
                    <div
                        className={cx(styles['time-stage'], {
                            [styles['show-line-on-last']]: showLineForLastStage,
                        })}
                        data-testid="stage"
                    >
                        <div className={styles['pointer-wrapper']}>
                            {pointer ? pointer : <div className={styles['circular-pointer']}></div>}
                        </div>
                        {stageComponent}
                    </div>
                );
            })}
        </div>
    );
};

export default Timeline;
